'use client';

import { useState } from 'react';

export const useCopyToClipboard = () => {
  const [success, setSuccess] = useState<boolean | null>(null);
  const [lastCopiedText, setLastCopiedText] = useState<string | null>(null);

  const handleCopy = async (code: string) => {
    try {
      await navigator.clipboard.writeText(code);
      setLastCopiedText(code);
      setSuccess(true);
      setTimeout(() => {
        if (lastCopiedText === code) {
          setSuccess(null);
          setLastCopiedText(null);
        }
      }, 1000);
    } catch (error) {
      setLastCopiedText(code);
      setSuccess(false);
    }
  };

  return { success, handleCopy };
};
